import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CronosMembersAddPage } from './cronos-members-add';

@NgModule({
  declarations: [
    CronosMembersAddPage,
  ],
  imports: [
    IonicPageModule.forChild(CronosMembersAddPage),
  ],
})
export class CronosMembersAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cronos-members-add/cronos-members-add.module.ts